import React from 'react';
import { Link } from 'react-router-dom';

import ResetPasswordTokenForm from './ResetPasswordTokenForm';
import { SuccessError } from './SuccessError';
import {
  Container, CardHeader, Row, Col, Card, CardBody, Alert
} from 'reactstrap';
import DashboardLogoGroup from '../../components/DashboardLogoGroup';



export default class ResetPassword extends React.Component {

  render() {

    let { onSubmit, success, error } = this.props;
    /*
    if (success && !error) {
      return (<div>
        <div className="col-md-12">
          <SuccessError text={`Thank you! your password is now reset`} error={false} />
        </div>
        <div style={{ textAlign: "center" }}>
          <br />
          <Link to="/login"><strong>You may now Login</strong></Link>
        </div>
      </div>);
    }
    */
    return (

      <div>
        <Row>
          <DashboardLogoGroup />
        </Row>
        <div className="app flex-row  animated fadeIn  mt-5 pt-5">

          <Container>
            <Row className="justify-content-center">
              <Col md="6">
                <Card>
                  <CardHeader>
                    Reset password
                </CardHeader>
                  <CardBody>
                    {success && !error ?
                      <Alert>
                        Thank you! your password is now reset...
                        <Link to="/login">You may now Login</Link>
                      </Alert>
                      : null}
                    {error ? <Alert color="danger" > {error.message}</Alert> : null}
                    <ResetPasswordTokenForm onSubmit={onSubmit} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPassword.js